import { uuid } from '@yola/ws-sdk';

const createKeywordOption = (keyword) => ({
  label: keyword,
  value: `${keyword}-${uuid()}`,
});

const getKeywordsList = (keywords) => {
  if (!keywords) {
    return [];
  }

  const keywordsList = keywords.split(',').map((keyword) => keyword.trim());

  return keywordsList.map(createKeywordOption);
};

export default getKeywordsList;
export { createKeywordOption };
